<template>
  <el-row align="middle">
    <el-col :lg="6" :md="12">
      <h3 class="font-color--gray margin-v-xs">Тип</h3>
      <p>Стандартный вычет</p>
    </el-col>
    <el-col :lg="6" :md="12">
      <h3 class="font-color--gray margin-v-xs">Сумма</h3>
      <p>{{ item.item.sum }}</p>
    </el-col>
    <el-col :lg="6" :md="12">
      <h3 class="font-color--gray margin-v-xs">Код вычета</h3>
      <p>{{ item.item?.other_attributes?.refund_code || 'Код дохода не определен' }}</p>
    </el-col>
    <el-col :lg="6" :md="12">
      <h3 class="font-color--gray margin-v-xs">Файл</h3>
      <p>{{ item.item?.other_attributes?.file_name || 'Файл не определен' }}</p>
    </el-col>
  </el-row>
</template>

<script lang="ts" setup>
import { AdditionalItem, Deduction } from '@/06-Entities/IncomeAndRefund'
import { UnwrapNestedRefs } from 'vue'

interface IProps {
  item: UnwrapNestedRefs<AdditionalItem<Deduction>>
}
const props = defineProps<IProps>()
</script>

<style lang="sass" scoped></style>
